module.exports = __webpack_public_path__ + "static/img/bg-contact.ea31fc27.png";